"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateItem = exports.serializeItemData = void 0;
__exportStar(require("./definitions"), exports);
__exportStar(require("./ItemValidator"), exports);
const amount_1 = require("./amount");
const checkbox_1 = require("./checkbox");
const date_1 = require("./date");
const email_1 = require("./email");
const FileUploadV2_1 = require("./FileUploadV2");
const multiLineText_1 = require("./multiLineText");
const multiSelect_1 = require("./multiSelect");
const placeholder_1 = require("./placeholder");
const switch_1 = require("./switch");
const text_1 = require("./text");
const slackMessage_1 = require("./slackMessage");
const schedule_1 = require("./schedule");
const userPicker_1 = require("./userPicker");
const custom_1 = require("./custom");
const customV2_1 = require("./customV2");
const singleSelect_1 = require("./singleSelect");
const signature_1 = require("./signature");
const checklist_1 = require("./checklist");
const rating_1 = require("./rating");
const video_1 = require("./video");
const location_1 = require("./location");
const serializeItemData = (item, type) => {
    const itemRenderDataSafe = {
        ...item,
        data: item.data || {},
    };
    switch (type) {
        case "Amount":
            return (0, amount_1.serializeAmount)(itemRenderDataSafe);
        case "Checkbox":
            return (0, checkbox_1.serializeCheckbox)(itemRenderDataSafe);
        case "Checklist":
            return (0, checklist_1.serializeChecklist)(itemRenderDataSafe);
        case "Custom":
            return (0, custom_1.serializeCustom)(itemRenderDataSafe);
        case "CustomV2":
            return (0, customV2_1.serializeCustomV2)(itemRenderDataSafe);
        case "Date":
            return (0, date_1.serializeDate)(itemRenderDataSafe);
        case "DateTime":
            return (0, date_1.serializeDate)(itemRenderDataSafe);
        case "Email":
            return (0, email_1.serializeEmail)(itemRenderDataSafe);
        case "FileUploadV2":
            return (0, FileUploadV2_1.serializeFileUploadV2)(itemRenderDataSafe);
        case "Location":
            return (0, location_1.serializeLocation)(itemRenderDataSafe);
        case "MultiLineText":
            return (0, multiLineText_1.serializeMultiLineText)(itemRenderDataSafe);
        case "MultiSelect":
            return (0, multiSelect_1.serializeMultiSelect)(itemRenderDataSafe);
        case "Rating":
            return (0, rating_1.serializeRating)(itemRenderDataSafe);
        case "Schedule":
            return (0, schedule_1.serializeSchedule)(itemRenderDataSafe);
        case "Signature":
            return (0, signature_1.serializeSignature)(itemRenderDataSafe);
        case "SingleSelect":
            return (0, singleSelect_1.serializeSingleSelect)(itemRenderDataSafe);
        case "SlackMessage":
            return (0, slackMessage_1.serializeSlackMessage)(itemRenderDataSafe);
        case "Switch":
            return (0, switch_1.serializeSwitch)(itemRenderDataSafe);
        case "Text":
            return (0, text_1.serializeText)(itemRenderDataSafe);
        case "UserPicker":
            return (0, userPicker_1.serializeUserPicker)(itemRenderDataSafe);
        case "Video":
            return (0, video_1.serializeVideo)(itemRenderDataSafe);
        default:
            return (0, placeholder_1.serializePlaceholder)(type);
    }
};
exports.serializeItemData = serializeItemData;
const validateItem = (item) => {
    switch (item.type) {
        case "Amount":
            return (0, amount_1.validateAmount)(item);
        case "Checkbox":
            return (0, checkbox_1.validateCheckbox)(item);
        case "Checklist":
            return (0, checklist_1.validateChecklist)(item);
        case "Custom":
            return (0, custom_1.validateCustom)(item);
        case "CustomV2":
            return (0, customV2_1.validateCustomV2)(item);
        case "Date":
            return (0, date_1.validateDate)(item);
        case "DateTime":
            return (0, date_1.validateDate)(item);
        case "Email":
            return (0, email_1.validateEmail)(item);
        case "FileUploadV2":
            return (0, FileUploadV2_1.validateFileUploadV2)(item);
        case "Location":
            return (0, location_1.validateLocation)(item);
        case "MultiLineText":
            return (0, multiLineText_1.validateMultiLineText)(item);
        case "MultiSelect":
            return (0, multiSelect_1.validateMultiSelect)(item);
        case "Rating":
            return (0, rating_1.validateRating)(item);
        case "Schedule":
            return (0, schedule_1.validateSchedule)(item);
        case "Signature":
            return (0, signature_1.validateSignature)(item);
        case "SingleSelect":
            return (0, singleSelect_1.validateSingleSelect)(item);
        case "SlackMessage":
            return (0, slackMessage_1.validateSlackMessage)(item);
        case "Subquest":
            return { valid: true };
        case "Switch":
            return (0, switch_1.validateSwitch)(item);
        case "Text":
            return (0, text_1.validateText)(item);
        case "UserPicker":
            return (0, userPicker_1.validateUserPicker)(item);
        case "Video":
            return (0, video_1.validateVideo)(item);
        default:
            return (0, placeholder_1.validatePlaceholder)(item);
    }
};
exports.validateItem = validateItem;
//# sourceMappingURL=index.js.map